/**
 * External dependencies
 */
import { registerCheckoutBlock} from '@woocommerce/blocks-checkout';
import { getSetting } from '@woocommerce/settings';
/**
 * Internal dependencies
 */
import Block  from './block';
import metadata from './block.json';
import './style.scss';
const cfeSettings = getSetting('thwcfe-block-integration_data', '');
const { allSections } = cfeSettings;
const { additional_info } = allSections || {};

if (additional_info && Object.keys(additional_info).length > 0) {

	registerCheckoutBlock( {
		metadata,
		component: Block,
	} );
}